// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminBusinessReferenceResponse

export type AdminBusinessReferenceApiResponse = {
	id: string;
	name: string;
};

export type AdminBusinessReference = {
	id: string;
	name: string;
};

export function hydrateAdminBusinessReference(data: AdminBusinessReferenceApiResponse): AdminBusinessReference {
	return { ...data };
}